// import Vue from 'vue'
// import App from './App.vue'

// Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')


// src/main.js

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css
import '@/styles/element-variables.scss'

//克隆库
import _ from "lodash"
Vue.prototype._ = _

Vue.use(ElementUI)

//公共组件
import MfTable from '@/components/mf-table'
import MfSearchSelect from '@/components/mf-search-select'

Vue.use(MfTable); //表格
Vue.use(MfSearchSelect);

//引入全局公共方法
import common from './utils/functions'
Vue.use(common)

// constantSystemRoutes
import { constantBaseRoutes, constantRoutes } from './router'
import Layout from '@/layout'

/**
 * 将菜单数据中的 component 路径字符串转换为动态导入函数
 * @param {Object} route - 路由配置对象
 * @returns {Object} 处理后的路由配置对象
 */
function restoreRouteComponent(route) {
  if (!route) return null;
  
  // 如果 component 是字符串路径，转换为动态导入函数
  if (typeof route.component === 'string') {
    let componentPath = route.component;
    
    // 处理 Layout 组件
    if (componentPath === 'Layout' || componentPath === '@/layout') {
      route.component = Layout;
    } else {
      // 移除开头的斜杠
      componentPath = componentPath.replace(/^\/+/, '');
      
      // 如果路径已经是完整路径（以 @/views 开头），直接使用
      if (componentPath.startsWith('@/views')) {
        route.component = () => import(componentPath);
      } else if (componentPath.startsWith('views/')) {
        // 如果路径已经以 views/ 开头，添加 @/ 前缀
        componentPath = `@/${componentPath}`;
        route.component = () => import(componentPath);
      } else {
        // 否则，假设路径是相对于 views 目录的
        componentPath = `@/views/${componentPath}`;
        route.component = () => import(componentPath).catch(err => {
          console.error(`组件加载失败: ${componentPath}`, err);
          return import('@/views/404');
        });
      }
    }
  }
  
  // 递归处理子路由
  if (route.children && Array.isArray(route.children)) {
    route.children = route.children
      .map(child => restoreRouteComponent(child))
      .filter(child => child !== null);
  }
  
  return route;
}

/**
 * 从 localStorage 加载缓存的菜单树并动态加载路由
 */
function loadMenusFromCache() {
  const cachedMenus = localStorage.getItem("menus");
  
  if (cachedMenus) {
    try {
      let menus = JSON.parse(cachedMenus);
      
      // 恢复路由配置中的 component（从字符串转换为动态导入函数）
      menus = menus
        .map(menu => restoreRouteComponent(menu))
        .filter(menu => menu !== null);
      
      console.log("从缓存加载菜单路由:", menus);
      
      // 重置路由并添加缓存的菜单路由
      router.options.routes = menus;
      router.addRoutes(menus);
      
      return true;
    } catch (error) {
      console.error("加载缓存的菜单失败:", error);
      localStorage.removeItem("menus");
      return false;
    }
  }
  
  return false;
}

function convertMapRouter(permissions) {
  let routes = [];
  let allroutest = [];
  // let base = copyDeep(constantBaseRoutes);
  // let droute = copyDeep(constantRoutes);
  // allroutest = base.concat(droute);
  allroutest = constantBaseRoutes.concat(constantRoutes);
  allroutest.forEach((item,index)=>{
    if(item.permission!=undefined){
      let hasPermissionMenuArr = [];
      hasPermissionMenuArr = item.children.filter(child=>{
        if(child.permission != undefined){
          if(hasPremission(permissions,child.permission)){
            return child;
          }
        } else{
          return child;
        }
      });
      if(hasPermissionMenuArr.length>0){
        item.children = hasPermissionMenuArr;
        routes.push(item);
      }
    } else{
      if(item.children.length === 1){
        routes.push(item);
      } else{
        let len = routes.push(item);
        let childrenArr = [];
        childrenArr = item.children.filter(child=>{
          return child;
        });
        let handledItem = JSON.parse(JSON.stringify(routes[len-1]));
        handledItem.children = childrenArr;
        routes.splice(len - 1,1,handledItem);
      }
    }
  })
  console.log("main-constantRoutes2",constantRoutes);
  return routes;
}

function hasPremission(permissions,permission){
  return permissions.indexOf(permission)>-1;
}

/**
 * 将路由配置中的 component 函数转换为路径字符串，以便保存到 localStorage
 * @param {Object} route - 路由配置对象
 * @returns {Object} 转换后的路由配置对象
 */
function convertRouteComponentToString(route) {
  if (!route) return null;
  
  const convertedRoute = JSON.parse(JSON.stringify(route));
  
  // 处理 component
  if (route.component) {
    if (route.component === Layout) {
      // Layout 组件
      convertedRoute.component = 'Layout';
    } else if (typeof route.component === 'function') {
      // 动态导入函数，尝试从函数体中提取路径
      const funcStr = route.component.toString();
      // 匹配 import('路径') 或 import("路径")
      const match = funcStr.match(/import\(['"]([^'"]+)['"]\)/);
      if (match && match[1]) {
        convertedRoute.component = match[1];
      } else {
        // 如果无法提取，使用空字符串
        convertedRoute.component = '';
      }
    } else if (typeof route.component === 'string') {
      // 已经是字符串，直接使用
      convertedRoute.component = route.component;
    }
  }
  
  // 递归处理子路由
  if (route.children && Array.isArray(route.children)) {
    convertedRoute.children = route.children
      .map(child => convertRouteComponentToString(child))
      .filter(child => child !== null);
  }
  
  return convertedRoute;
}

// 页面刷新时，优先从缓存加载菜单树
// 如果缓存不存在，则使用 permissions 方式加载
if (!loadMenusFromCache()) {
  // 如果缓存加载失败，尝试使用 permissions 方式
  if(localStorage.getItem("permissions") != null){
    let permissions = JSON.parse(localStorage.getItem("permissions"));
    let menus = convertMapRouter(permissions);
    
    // 为了保存到 localStorage，需要将 component 函数转换为路径字符串
    const menusForStorage = menus
      .map(menu => convertRouteComponentToString(menu))
      .filter(menu => menu !== null);
    
    localStorage.setItem("menus", JSON.stringify(menusForStorage));
    
    router.options.routes = [];
    router.options.routes = menus;
    router.addRoutes(router.options.routes);
  }
}

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})